import { createAction } from '@lifesize/typescript-react-redux-utils';

export const FETCH_SSO_STATUS = 'FETCH_SSO_STATUS';

export const fetchSsoStatus = () => {
  return createAction( FETCH_SSO_STATUS );
};
